<template>
  <div class="mt-base flex w-full vx-row no-gutter justify-center">
    <div class="vx-col sm:w-5/6 md:w-5/6 lg:w-5/6 xl:w-2/3 sm:m-0 m-4">
      <div class="flex w-full mb-base justify-center">
        <img
          src="@/assets/images/project/hexasense-logo.png"
          alt="logo"
          width="220px"
          height="100%"
        />
      </div>
      <div class="vx-card px-10 py-4 mb-base">
        <div class="text-center mb-base mt-base">
          <h4 class="mb-0">{{ $t("authFooter.CookiePolicy") }}</h4>
        </div>
        <div class="mb-base">
          <template v-if="isPageLoading == true">
            <page-loader :size="'w-10 h-10'" :height="400" class="mt-8"/>
          </template>
          <template v-else>
            <div class="mb-base text-right">
              <small class="font-bold">
                {{ $t("authFooter.updateText") }} {{ policyUpdate }}
              </small>
            </div>

            <div v-html="policyContent"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../i18n/i18n.js'
const moment = require('moment')
import PageLoader from '../../components/Loader.vue'
export default {
  components:{PageLoader},
  data () {
    return {
      policyContent: '',
      policyUpdate: '',
      isPageLoading: true
    }
  },
  mounted () {
    this.getPolicy()
  },
  methods: {
    getPolicy () {
      this.$store
        .dispatch('getPolicy', '?slug=cookie-policy')
        .then((response) => {
          response.data.map((value) => {
            if (value.slug === 'cookie-policy') {
              this.policyContent = value.content
              this.policyUpdate = moment(value.updated_at).format('DD.MM.YYYY')
            }
          })
          this.isPageLoading = false
        })
        .catch((error) => {
          this.isPageLoading = false
          this.$router.push('/hives').catch(() => {})
          this.errorMsg(error)
        })
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.height-400{
    height: 400px;
}
</style>
